export class UpdateDlsgPolicyResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dlsgPolicy",
            "baseName": "dlsgPolicy",
            "type": "DlsgPolicy",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateDlsgPolicyResponse.attributeTypeMap;
    }
    constructor() {
    }
}
